import { Backdrop, ButtonTertiary, IconMenu, IconX, screenMdMin, screenXsMin, spacer16, spacer4, spacer40, } from '@spotify-internal/encore-web';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { Menu } from './Menu';
import { useBackdropMenu } from '../../hooks/useBackdropMenu';
import { useS4AMastheadContext } from '../../../S4AMastheadProvider';
import { useUserState } from '../../hooks/useUserState';
import { Wait } from '../../Wait';
import { HomeLink } from '../../../HomeLink/HomeLink';
import { S4ALogo } from '../../S4ALogo';
import { NavBarWrapper } from '../../NavBarWide/NavBarWrapper';
import { flyoutTransitionMixin } from '../../FlyoutMenu/config';
const WrapperCompact = styled(NavBarWrapper) `
  background: transparent;
`;
const MenuButtonWrapper = styled.div `
  display: none;
  @media (max-width: ${screenMdMin}) {
    display: flex;
    position: relative;
  }
`;
const OpenMenuButton = styled(ButtonTertiary) `
  ${flyoutTransitionMixin('color')}
  color: ${props => props.theme.text};
  padding-inline-end: 0;

  &:hover {
    color: ${props => props.theme.text};
    cursor: pointer;
  }

  &::after {
    display: none;
  }
`;
const CloseMenuButton = styled(ButtonTertiary) `
  ${flyoutTransitionMixin('color')}
  color: ${props => props.theme.text};
  padding-inline-end: 0;
  position: absolute;
  inset-inline-end: ${spacer40};
  top: ${spacer4};
  z-index: 1021;

  &:hover {
    color: ${props => props.theme.text};
    cursor: pointer;
  }

  &::after {
    display: none;
  }

  @media (max-width: ${screenXsMin}) {
    inset-inline-end: ${spacer16};
  }
`;
export const SideMenu = ({ forcedUserState }) => {
    const { language, mastheadData } = useS4AMastheadContext();
    const userState = useUserState(forcedUserState);
    const backdropRef = useRef(null);
    const { handleOnKeyDown, closeBackdrop, openBackdrop, backdropOpen, closeBtnRef, openBtnRef, } = useBackdropMenu();
    if (userState === 'loading' || !mastheadData) {
        return React.createElement(Wait, null);
    }
    const headerEntry = mastheadData.fields.header;
    return (React.createElement(WrapperCompact, null,
        React.createElement(HomeLink, { label: headerEntry.fields.navBarLogoLabel, style: { zIndex: 100 } },
            React.createElement(S4ALogo, { condensed: true, label: headerEntry.fields.navBarLogoLabel, height: 28 })),
        React.createElement(MenuButtonWrapper, null,
            React.createElement(OpenMenuButton, { size: "medium", "data-testid": "navigation-sidemenu-trigger", iconOnly: IconMenu, tabIndex: 0, onKeyDown: handleOnKeyDown, onClick: openBackdrop, "aria-label": mastheadData.fields.dropdownMenuLabelOpen, "aria-expanded": backdropOpen, ref: openBtnRef })),
        backdropOpen && (React.createElement(Backdrop, { onClose: closeBackdrop, ref: backdropRef, withPortal: true, dir: language.dir },
            React.createElement("div", { className: "encore-creator-light-theme" },
                React.createElement("div", { className: "encore-inverted-dark-set" },
                    React.createElement(CloseMenuButton, { size: "medium", iconOnly: IconX, onClick: closeBackdrop, onKeyDown: handleOnKeyDown, ref: closeBtnRef, tabIndex: 0, "aria-label": mastheadData.fields.dropdownMenuLabelClose }),
                    React.createElement(Menu, { language: language, userState: userState, mastheadData: mastheadData, closeBackdrop: closeBackdrop })))))));
};
//# sourceMappingURL=index.js.map